import { useEffect } from 'react';

/**
 * Ensures Ctrl/Cmd+R reloads in hosts that swallow the shortcut (e.g. IDE browser).
 * Does not touch F5 / Ctrl+F5 / Ctrl+Shift+R — those must stay as the browser's hard refresh.
 */
export default function GlobalShortcuts() {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (!(e.ctrlKey || e.metaKey)) return;
      if (e.shiftKey || e.altKey) return;
      const key = e.key?.toLowerCase?.() || '';
      if (key !== 'r') return;
      // Never steal hard-reload chords (Ctrl+F5 uses key F5; Ctrl+Shift+R uses shift).
      if (e.key === 'F5' || e.code === 'F5') return;
      e.preventDefault();
      window.location.reload();
    };
    window.addEventListener('keydown', onKeyDown, { capture: true });
    return () => window.removeEventListener('keydown', onKeyDown, { capture: true });
  }, []);
  return null;
}
